const CategoryTypes = {
    GET_CATEGORIES: "GET_CATEGORIES",
    GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS"
};

export { CategoryTypes };
